import { useTranslation } from 'react-i18next'

/** A neutral loading placeholder shaped like the content it replaces. */
export function SkeletonGrid({ count = 6 }: { count?: number }) {
  return (
    <div
      className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3"
      aria-busy="true"
      aria-live="polite"
    >
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className="animate-pulse">
          <div className="aspect-4/5 rounded-[var(--radius-card)] bg-stone-200/70" />
          <div className="mt-3 h-4 w-2/3 rounded bg-stone-200/70" />
        </div>
      ))}
    </div>
  )
}

export function LoadingLine() {
  const { t } = useTranslation()
  return (
    <p className="py-10 text-center text-sm text-stone-500" aria-live="polite">
      {t('gallery.loading')}
    </p>
  )
}

export function ErrorState({ onRetry }: { onRetry?: () => void }) {
  const { t } = useTranslation()
  return (
    <div className="py-16 text-center" role="alert">
      <p className="text-stone-600">{t('errors.loadFailed')}</p>
      {onRetry && (
        <button type="button" onClick={onRetry} className="btn btn-secondary mt-4">
          {t('errors.retry')}
        </button>
      )}
    </div>
  )
}

export function EmptyState({ message }: { message: string }) {
  return <p className="py-16 text-center text-stone-500">{message}</p>
}
